import { createRootRoute, Outlet } from '@tanstack/react-router';
import { TanStackRouterDevtools } from '@tanstack/router-devtools';
import { Suspense } from 'react';
import { NotFoundPage } from '@/features/errors/NotFoundPage';
import { AuthErrorPage } from '@/features/errors/AuthErrorPage';

export const Route = createRootRoute({
  component: RootComponent,
  notFoundComponent: NotFoundPage,
  errorComponent: RootErrorComponent,
});

function RootComponent() {
  return (
    <>
      <Outlet />
      {import.meta.env.DEV && (
        <Suspense fallback={null}>
          <TanStackRouterDevtools position="bottom-right" />
        </Suspense>
      )}
    </>
  );
}

interface RootErrorComponentProps {
  error: Error;
}

function RootErrorComponent({ error }: RootErrorComponentProps) {
  const message = error.message ?? '';
  const isAuthError =
    /unauthor|forbidden|401|403|sessione|token|expired/i.test(message) ||
    /AuthError|Unauthorized/i.test(error.name ?? '');

  if (isAuthError) {
    return <AuthErrorPage reason={message} />;
  }
  return <NotFoundPage />;
}
